import { render, staticRenderFns } from "./type14.vue?vue&type=template&id=822e3068&scoped=true&"
import script from "./type14.vue?vue&type=script&lang=js&"
export * from "./type14.vue?vue&type=script&lang=js&"
import style0 from "./type14.vue?vue&type=style&index=0&id=822e3068&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822e3068",
  null
  
)

export default component.exports